<div class="row col-12 col-sm-12 my-account-container open-position-container">

  <!-- LEFT NAV -->
  <div class="col-3 d-one d-sm-none col-sm-3 my-account-left-nav">
    <app-my-account-left-sidenav
      [navState]="'MyOrdersNavNode'"
      [childNavState]="'OpenPositionsNavNode'">
    </app-my-account-left-sidenav>
  </div>

  <!-- RIGHT CONTENT -->
  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    @if (canLoadPage|async; as canLoad) {
      <div class="my-section-box">
        <h1 class="myProfileTopHeader m-0">{{ 'common.text_account_open_position' | cxTranslate }}
        </h1>
        @if (openPositionData$ | async; as openPositionData) {
          <div class="myProfileBody option-position-body">
            <form [formGroup]="searchOpenPositionForm" (ngSubmit)="onSearchItemsList()">
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="form-group">
                    <label class="control-label">{{ 'common.text_account_customerID' | cxTranslate }}</label>
                    <div class="customerIdContainer">
                      <div class="select-box">
                        <select formControlName="defaultSoldTo" class="customerSelect" (change)="onCustomerSelect($event)">
                          @for (customer of openPositionData.b2bunits; track customer) {
                            <option [value]="customer?.uid">
                              {{ customer?.salesArea1 }}&nbsp;|&nbsp;
                              {{ customer?.salesArea2 | cxTranslate }}&nbsp;|&nbsp;
                              {{ customer?.salesArea3 }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="myProfileButtonContainer form-group">
                    <label class="control-label">{{ 'common.text_account_table_header_poNumber' | cxTranslate }}</label>
                    <input formControlName="poNumber" class="form-control" type="text" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-group">
                    <label class="control-label">{{ 'common.text_account_kbOrderNumber' | cxTranslate }}</label>
                    <input formControlName="orderNo" class="form-control" type="text" />
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 order-status-datepicker">
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      <div class="form-group">
                        <label class="control-label">{{ 'common.text_account_OrderDate' | cxTranslate }}</label>
                        <span class="item_delivery-datepicker">
                          <div class="form-group">
                            <input class="form-control bsdpicker kb-datePickerIcon outline" placeholder="Datepicker"
                              bsDatepicker formControlName="startDate" [maxDate]="today"
                              [bsConfig]="{ dateInputFormat: bsConfigFormat, showWeekNumbers:false, displayOneMonthRange: true }">
                            </div>
                          </span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <div class="form-group">
                          <label class="control-label">{{ 'common.text_account_OrderDateTo' | cxTranslate }}</label>
                          <span class="item_delivery-datepicker">
                            <div class="form-group">
                              <input class="form-control bsdpicker kb-datePickerIcon outline" placeholder="Datepicker"
                                bsDatepicker formControlName="endDate" [maxDate]="today"
                                [bsConfig]="{ dateInputFormat: bsConfigFormat, showWeekNumbers:false, displayOneMonthRange: true }">
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      <div class="form-group">
                        <label class="control-label">{{ 'common.text_account_kbpartNumber' | cxTranslate }}</label>
                        <input formControlName="partNo" class="form-control" type="text" specialIsAlphaNumeric />
                      </div>
                    </div>
                    @if (openPositionData?.showCoworkersOrder) {
                      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 checkbox-coworker"
                        >
                        <div class="form-group">
                          <div class="checkbox">
                            <label class="control-label" for="coWorkers">
                              <input class="coWorkers-check" formControlName="showCoworkersOrder" type="checkbox" />
                              {{ 'common.text_Show_orders_of_coworkers' | cxTranslate }}
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="row mt-4">
                    <div class="col-xs-12 col-sm-12">
                      <div class="row submit-buttons">
                        <div class="col-xs-12 width-auto">
                          <button type="reset" (click)="reset()" class="btn btn-primary btn-blue reset-hover">
                            {{ 'common.text_account_reset' | cxTranslate }}
                          </button>
                        </div>
                        <div class="col-xs-12 width-auto">
                          <button type="submit" class="btn btn-primary search-btn" [disabled]="!searchOpenPositionForm.valid">
                            {{ 'common.text_account_search' | cxTranslate }}
                            <img class="hover-img" src="/icons/link-grey.svg" alt="Link Icon" style="width: 20px;" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            }
            <kb-open-position-table [searchItemsList]="searchItemsList" [soldOrderId]="selectedCustomerId"
              (sortEvent)="sort($event)" (pageEvent)="page($event)" [dateFormat]="resultDateFormat"
            (exportToExcel)="exportToExcelFile($event)"></kb-open-position-table>
          </div>
        }
      </div>
    </div>
